import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export const LandingTableHeader = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Published State</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Paused/Live</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Last Modified</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Last Modified By</TableCell>
        <TableCell width="auto"></TableCell>
      </TableRow>
    </TableHead>
  );
};
